import React, { Component } from "react";
import { observer } from "mobx-react";

import { UnControlled as CodeMirror } from "react-codemirror2";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";

@observer
class Editor extends Component {
  //===========================================================================

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.editor !== nextProps.editor) return true;
    return false;
  }
  //===========================================================================

  render() {
    const { code } = this.props;
    return (
      <CodeMirror
        value={code}
        options={{
          mode: "javascript",
          theme: "material",
          lineNumbers: true
        }}
        onChange={this.changeInput}
      />
    );
  }
  //===========================================================================

  changeInput = (editor, data, value) => {
    const { changeCode } = this.props;
    changeCode(value);
  };
  //===========================================================================
}

export default Editor;
